export var isCustomInterval = function isCustomInterval(interval) {
  return interval && interval.includes('every');
};